/* Product card colour swatches (snippets/product-swatches.liquid).
   One delegated listener, so every card on every page works, including cards
   added to the page later. Click: mark the swatch, point the card's links at
   ?variant=ID, show that variant's own image and update the colour name under
   the title. A colour without its own image shows the product's main image. */
(() => {
  'use strict';
  if (window.EssaintSwatches) return;
  window.EssaintSwatches = true;

  const cardImage = card => card.querySelector('.product-photo img:not(.alternate)');

  const withVariant = (href, id) => {
    try {
      const url = new URL(href, location.origin);
      url.searchParams.set('variant', id);
      return url.pathname + url.search + url.hash;
    } catch (e) { return href; }
  };

  // Fetch the image at the size the card will use, so the swap is instant.
  const warmed = new Map();
  const warm = (img, src, srcset) => {
    const key = src + '|' + (img.sizes || '');
    if (!warmed.has(key)) {
      const pre = new Image();
      if (img.sizes) pre.sizes = img.sizes;
      if (srcset) pre.srcset = srcset;
      pre.src = src;
      warmed.set(key, pre.decode ? pre.decode().catch(() => {}) : Promise.resolve());
    }
    return warmed.get(key);
  };

  const show = (img, src, srcset) => {
    img.dataset.swatchSrc = src;
    img.loading = 'eager';
    warm(img, src, srcset).then(() => {
      if (img.dataset.swatchSrc !== src) return; // a newer tap won
      if (srcset) img.srcset = srcset; else img.removeAttribute('srcset');
      img.src = src;
    });
  };

  const remember = img => {
    if (img.dataset.originalSrc) return;
    img.dataset.originalSrc = img.getAttribute('src') || '';
    img.dataset.originalSrcset = img.getAttribute('srcset') || '';
  };

  // Hover (desktop) or first touch (mobile): load the colour's image ahead of the tap.
  const prefetch = e => {
    const swatch = e.target.closest && e.target.closest('[data-swatch][data-src]');
    if (!swatch) return;
    const card = swatch.closest('.product-card'), img = card && cardImage(card);
    if (img) warm(img, swatch.dataset.src, swatch.dataset.srcset);
  };
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  document.addEventListener('click', e => {
    const swatch = e.target.closest('[data-swatch]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    const card = swatch.closest('.product-card');
    if (!card) return;

    card.querySelectorAll('[data-swatch]').forEach(b => b.setAttribute('aria-pressed', String(b === swatch)));

    const label = card.querySelector('[data-card-colour]');
    if (label && swatch.title) label.textContent = swatch.title;

    const id = swatch.dataset.variantId;
    if (id) card.querySelectorAll('a[href*="/products/"]').forEach(a => { a.href = withVariant(a.getAttribute('href'), id); });

    const img = cardImage(card);
    if (!img) return;
    remember(img);
    card.classList.add('is-variant-picked');
    if (swatch.dataset.src) show(img, swatch.dataset.src, swatch.dataset.srcset);
    else show(img, img.dataset.originalSrc, img.dataset.originalSrcset);
  });
})();
